import React from 'react';
import { styles } from './BreadcrumbItem.css';
import { BreadcrumbItemProps } from './Breadcrumbs';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { Link } from '@jbhi-fi/components/src/PlatformFunctionality';

export const BreadcrumbItem = ({ href, label, isActive = false, color }: BreadcrumbItemProps) => {
  return (
    <Link
      href={href}
      className={styles.item}
      style={{ fontWeight: isActive ? 700 : 400, color: color ?? palette.primary.neutral }}
    >
      {label}
    </Link>
  );
};
